import { history } from 'app/history';

import { loadProfile, logoutUser, refreshTokens, selectLoggedIn, setActiveUser } from 'features/auth/auth.slice';

import { TimingConstants } from './constants/timing-constants';
import { injectStoreToServices } from './http';
import { messagingService } from './services/messaging.service';
import { AppStore, dispatch } from './store';
import { SecurityUtils } from './utils/security-utils';

/**
 * This function is called once at the app initialization time.
 *
 * You can do whatever you need to do at the start an an app. Like register timers dispatch one time actions etc.
 */
export const startup = (store: AppStore): void => {
    injectStoreToServices(store); // must be called before any services are used

    // schedule logged in user profile load on app start
    dispatch(loadProfile());

    setInterval(() => {
        // schedule regular token checks
        if (!SecurityUtils.tokenExpiresSoon()) {
            // token is not expiring anytime soon
            return;
        }

        dispatch(refreshTokens()).subscribe({
            next: (val) => {
                if (selectLoggedIn(store.getState()) === val.valid) {
                    // already logged out, avoids react constantly re-rendering
                    return;
                }

                dispatch(setActiveUser(val));
            },
            error: (error: { error: string } | undefined) => {
                if (!SecurityUtils.tokenExpired()) {
                    // maybe another tab is refreshing stuff, just let it be for now, will keep retrying until expired
                    return;
                }
                if (error && error.error) {
                    messagingService.showError(error.error);
                }
                dispatch(logoutUser());
                history.push('/');
            },
        });
    }, TimingConstants.TOKEN_CHECK_INTERVAL);
};
